import { ReportView } from "@/components/common/account/AccountViews";

export default function ReportMobile() {
  return <ReportView isMobile={true} />;
}
